export default __webpack_public_path__ + "static/media/modal_hinge_door.ccd77e94.png";